import "./App.css";
import Navbar from './components/Navbar';
import About from './components/About';
import Skills from './components/Skills';
import Project from './components/Project';
import Education from './components/Education';
import Contact from './components/COntact';
import Footer from './components/Footer';
import BlurBlob from './components/BlurBlob';

function App() {
  return (
    <div className="bg-[#050414] text-white min-h-screen relative overflow-hidden selection:bg-[#8245ec] selection:text-white font-sans">

       {/* Ambient Glow Blob */}
       <BlurBlob position={{ top: '25%', left: '15%' }} size={{ width: '35vw', height: '45vh' }} />
       <BlurBlob position={{ top: '65%', left: '80%' }} size={{ width: '30vw', height: '40vh' }} />

       {/* Tech Grid Background Overlay */}
       <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f1a_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f1a_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none"></div>
       
       <div className="relative z-10">
         <Navbar />
         <About />
         <Skills />
         <Project />
         <Education />
         <Contact />
         <Footer />
       </div>

    </div>
  );
}

export default App;